export const DASHBOARD_MENU_KEY = "dashboard";
export const RESULT_PROCESSING_MENU_KEY = "result-processing";
export const DATA_SHEET_MENU_KEY = "date-sheet";
export const API_KEY = "api";

export type SidebarMenuKey =
	| typeof DASHBOARD_MENU_KEY
	| typeof RESULT_PROCESSING_MENU_KEY
	| typeof DATA_SHEET_MENU_KEY
	| typeof API_KEY;
